import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ViewportService {
	constructor() {}

	type: string;
	showFooter: boolean;
}
